import { v4 as uuid } from 'uuid';

import { CustomColumnHeader, CustomColumnItem, ID, LineItemChanges } from 'types';
import { Global } from '@utils/common';
import { createDefaultDisplayTextForDataType } from './createDefaultDisplayTextForDataType';

// TLC: We need to use I18n for this
const DEFAULT_NAME = 'Item';

export const createDefaultColumnValue = (lineItemId: ID, header: CustomColumnHeader): CustomColumnItem => {
  const newId = `new-${uuid()}`;
  const headerId = header.id;
  const columnType = header.column_type;
  const isSupplierVisible = header.is_supplier_visible;
  const orderIndex = header.column_order_index;
  const defaultDisplayText = createDefaultDisplayTextForDataType(header.data_type);

  return {
    answer_option: null,
    column_type: columnType,
    custom_column_header_id: headerId,
    display_text: defaultDisplayText,
    id: newId,
    is_supplier_visible: isSupplierVisible,
    line_item_id: lineItemId,
    new_header_index: orderIndex,
    qualifying_equality: '',
  };
};

const createDefaultCustomColumnItems = (lineItemId: string, headers?: CustomColumnHeader[]): Record<ID, CustomColumnItem> => {
  if (!headers?.length) return {};
  const values: Record<ID, CustomColumnItem> = {};

  headers
    .filter((header: CustomColumnHeader) => header.column_type !== undefined)
    .forEach((header: CustomColumnHeader): void => {
      const customColumnItem = createDefaultColumnValue(lineItemId, header);

      values[customColumnItem.id] = customColumnItem;
    });

  return values;
};

export const getDefaultLineItemForLot = ({ lotId, sno, name = DEFAULT_NAME, headers }: {
  headers?: CustomColumnHeader[];
  lotId: ID;
  name?: string;
  sno: number;
}): LineItemChanges => {
  const newId = `new-${uuid()}`;
  const { defaults } = Global.line_items;
  const defaultName = `${name?.length ? name : DEFAULT_NAME} ${sno}`;
  const columnValues = createDefaultCustomColumnItems(newId, headers);

  return {
    custom_column_items: columnValues,
    extended_quantity: defaults.extended_quantity,
    id: newId,
    lot_id: lotId,
    name: defaultName,
    price: defaults.price,
    quantity: defaults.quantity,
    sno,
    units: defaults.units,
  };
};
